import { ref, onMounted, onUnmounted } from 'vue';

interface Mq {
  xsmall: boolean;
  small: boolean;
  medium: boolean;
  large: boolean;
  xlarge: boolean;
  xxlarge: boolean;
  largeUp: boolean;
  current?: string;
}

export const useMediaQueries = () => {
  const breakpoints = {
    xsmall: 320,
    small: 640,
    medium: 768,
    large: 1024,
    xlarge: 1280,
    xxlarge: 1536,
  };
  const mq = ref<Mq>({
    xsmall: false,
    small: false,
    medium: false,
    large: true,
    xlarge: false,
    xxlarge: false,
    largeUp: true,
    current: '',
  });

  // a composable can update its managed state over time.
  const update = () => {
    const width = window.innerWidth;
    const { xsmall, small, medium, large, xlarge, xxlarge } = breakpoints;

    mq.value.xsmall = width >= xsmall && width < small;
    mq.value.small = width >= small && width < medium;
    mq.value.medium = width >= medium && width < large;
    mq.value.large = width >= large && width < xlarge;
    mq.value.xlarge = width >= xlarge && width < xxlarge;
    mq.value.xxlarge = width >= xxlarge;

    mq.value.largeUp = width >= large;

    mq.value.current = Object.keys(mq.value).find((key) => mq.value[key] === true);
  };

  onMounted(() => {
    window.addEventListener('resize', update);
    update();
  });
  onUnmounted(() => window.removeEventListener('resize', update));

  return {
    breakpoints,
    mq,
  };
};
